import {useQuery} from '@tanstack/react-query';
import {QUERY_CACHE_KEYS} from 'utils/constants';
import {useChekinSDK} from 'context/ChekinSDK';
import {useErrorToast} from 'hooks';
import {GuestTokenStorageHandler} from '@guestapp/sdk';

function useFetchParticipants() {
  const {getParticipants, isSuccessSDK} = useChekinSDK();
  const queryData = useQuery([QUERY_CACHE_KEYS.participants], () => getParticipants(), {
    enabled: isSuccessSDK && Boolean(GuestTokenStorageHandler.getToken()),
  });
  useErrorToast(queryData.error);

  return queryData;
}

export {useFetchParticipants};
